// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.pmannouncepg-inline-1 {
  text-align: center;
  padding: 60px 20px;
}

.pmannouncepg-inline-2 {
  margin: 0 auto 20px;
}

.pmannouncepg-inline-3 {
  font-size: 14px;
  color: #64748b;
}

.pmannouncepg-inline-4 {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 20px;
}

.pmannouncepg-inline-5 {
  font-family: 'Outfit', sans-serif;
  font-size: 22px;
  font-weight: 700;
  color: #0f172a;
  margin-bottom: 4px;
}

.pmannouncepg-inline-6 {
  font-size: 13px;
  color: #64748b;
  margin: 0;
}

.pmannouncepg-inline-7 {
  display: flex;
  gap: 12px;
}

.pmannouncepg-inline-8 {
  display: flex;
  align-items: center;
  background: #fff;
  border: 1px solid #e2e8f0;
  border-radius: 10px;
  padding: 0 12px;
  width: 260px;
  height: 42px;
}

.pmannouncepg-inline-9 {
  border: none;
  padding: 10px 8px;
  font-size: 13px;
  width: 100%;
  outline: none;
  background: transparent;
}

.pmannouncepg-inline-10 {
  height: 42px;
  padding: 0 18px;
}

.pmannouncepg-inline-11 {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 16px;
  margin-bottom: 24px;
}

.pmannouncepg-inline-12 {
  padding: 20px;
  border-left: 4px solid #4338ca;
}

.pmannouncepg-inline-13 {
  font-size: 13px;
  color: #64748b;
  margin-bottom: 8px;
}

.pmannouncepg-inline-14 {
  font-size: 36px;
  font-weight: 700;
  color: #4338ca;
  line-height: 1;
}

.pmannouncepg-inline-15 {
  font-size: 12px;
  color: #94a3b8;
  margin-top: 8px;
}

.pmannouncepg-inline-16 {
  padding: 20px;
  border-left: 4px solid #2563eb;
  background: #f8fafc;
}

.pmannouncepg-inline-17 {
  font-size: 13px;
  color: #64748b;
  margin-bottom: 8px;
}

.pmannouncepg-inline-18 {
  font-size: 36px;
  font-weight: 700;
  color: #2563eb;
  line-height: 1;
}

.pmannouncepg-inline-19 {
  font-size: 12px;
  color: #94a3b8;
  margin-top: 8px;
}

.pmannouncepg-inline-20 {
  padding: 20px;
  border-left: 4px solid #2563eb;
  background: #f8fafc;
}

.pmannouncepg-inline-21 {
  font-size: 13px;
  color: #64748b;
  margin-bottom: 8px;
}

.pmannouncepg-inline-22 {
  font-size: 36px;
  font-weight: 700;
  color: #2563eb;
  line-height: 1;
}

.pmannouncepg-inline-23 {
  font-size: 12px;
  color: #94a3b8;
  margin-top: 8px;
}

.pmannouncepg-inline-24 {
  padding: 20px;
  border-left: 4px solid #d97706;
  background: #f8fafc;
}

.pmannouncepg-inline-25 {
  font-size: 13px;
  color: #64748b;
  margin-bottom: 8px;
}

.pmannouncepg-inline-26 {
  font-size: 36px;
  font-weight: 700;
  color: #d97706;
  line-height: 1;
}

.pmannouncepg-inline-27 {
  font-size: 12px;
  color: #94a3b8;
  margin-top: 8px;
}

.pmannouncepg-inline-28 {
  display: flex;
  align-items: center;
  gap: 12px;
  margin-bottom: 24px;
  flex-wrap: wrap;
  background: #fff;
  padding: 12px 16px;
  border-radius: 12px;
  border: 1px solid #e2e8f0;
}

.pmannouncepg-inline-29 {
  font-size: 13px;
  font-weight: 600;
  color: #0f172a;
}

.pmannouncepg-inline-30 {
  display: flex;
  gap: 8px;
}

.pmannouncepg-inline-36 {
  display: flex;
  align-items: center;
  gap: 8px;
  margin-left: auto;
}

.pmannouncepg-inline-37 {
  font-size: 13px;
  color: #64748b;
}

.pmannouncepg-inline-38 {
  width: 200px;
  padding: 6px 12px;
  font-size: 12px;
}

.pmannouncepg-inline-39 {
  margin-bottom: 20px;
  background: #eff6ff;
  border-color: #86efac;
  color: #166534;
}

.pmannouncepg-inline-40 {
  text-align: center;
  padding: 80px 20px;
  background: #fff;
  border: 2px dashed #e2e8f0;
  border-radius: 16px;
}

.pmannouncepg-inline-41 {
  font-size: 56px;
  margin-bottom: 20px;
}

.pmannouncepg-inline-42 {
  font-size: 20px;
  font-weight: 700;
  color: #0f172a;
  margin-bottom: 12px;
}

.pmannouncepg-inline-43 {
  font-size: 14px;
  color: #64748b;
  margin-bottom: 24px;
  max-width: 500px;
  margin: 0 auto 24px;
}

.pmannouncepg-inline-44 {
  padding: 12px 24px;
  font-size: 14px;
}

.pmannouncepg-inline-45 {
  display: flex;
  flex-direction: column;
  gap: 16px;
}

.pmannouncepg-inline-46 {
  padding: 0;
  border: 1px solid #e2e8f0;
  border-radius: 12px;
  overflow: hidden;
  transition: all 0.2s;
  box-shadow: 0 1px 3px rgba(0,0,0,0.05);
}

.pmannouncepg-inline-47 {
  padding: 16px 20px;
  background: #f8fafc;
  border-bottom: 1px solid #e2e8f0;
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.pmannouncepg-inline-48 {
  display: flex;
  align-items: center;
  gap: 12px;
}

.pmannouncepg-inline-49 {
  font-size: 16px;
  font-weight: 700;
  color: #0f172a;
  margin-bottom: 4px;
}

.pmannouncepg-inline-50 {
  display: flex;
  gap: 16px;
  font-size: 12px;
  color: #64748b;
}

.pmannouncepg-inline-52 {
  padding: 16px 20px;
}

.pmannouncepg-inline-53 {
  font-size: 13px;
  line-height: 1.6;
  color: #334155;
  display: -webkit-box;
  -webkit-line-clamp: 3px;
  -webkit-box-orient: vertical;
  overflow: hidden;
  text-overflow: ellipsis;
  margin-bottom: 16px;
}

.pmannouncepg-inline-54 {
  display: flex;
  justify-content: space-between;
  align-items: center;
  border-top: 1px solid #f1f5f9;
  padding-top: 16px;
  margin-top: 8px;
}

.pmannouncepg-inline-55 {
  font-size: 12px;
  color: #64748b;
}

.pmannouncepg-inline-56 {
  font-weight: 600;
  color: #475569;
}

.pmannouncepg-inline-57 {
  margin-left: 12px;
}

.pmannouncepg-inline-58 {
  display: flex;
  gap: 8px;
}

.pmannouncepg-inline-59 {
  padding: 6px 14px;
  font-size: 12px;
}

.pmannouncepg-inline-60 {
  padding: 6px 14px;
  font-size: 12px;
}

.pmannouncepg-inline-61 {
  padding: 6px 14px;
  font-size: 12px;
  border-color: #fee2e2;
  color: #ef4444;
}

.pmannouncepg-inline-62 {
  resize: vertical;
}

.pmannouncepg-inline-63 {
  display: flex;
  gap: 12px;
  justify-content: flex-end;
  margin-top: 24px;
}

.pmannouncepg-inline-64 {
  resize: vertical;
}

.pmannouncepg-inline-65 {
  display: flex;
  gap: 12px;
  justify-content: flex-end;
  margin-top: 24px;
}

.pmannouncepg-inline-66 {
  background: linear-gradient(135deg, #f8fafc 0%, #f1f5f9 100%);
  border-radius: 16px;
  padding: 28px;
  margin-bottom: 24px;
}

.pmannouncepg-inline-67 {
  display: flex;
  align-items: center;
  gap: 16px;
  margin-bottom: 20px;
}

.pmannouncepg-inline-68 {
  font-size: 24px;
  font-weight: 700;
  color: #0f172a;
  margin-bottom: 8px;
}

.pmannouncepg-inline-70 {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 16px;
  background: #fff;
  padding: 20px;
  border-radius: 12px;
  border: 1px solid #e2e8f0;
}

.pmannouncepg-inline-71 {
  font-size: 12px;
  color: #64748b;
  margin-bottom: 4px;
}

.pmannouncepg-inline-72 {
  font-size: 15px;
  font-weight: 600;
}

.pmannouncepg-inline-73 {
  font-size: 12px;
  color: #64748b;
  margin-bottom: 4px;
}

.pmannouncepg-inline-74 {
  font-size: 15px;
  font-weight: 600;
}

.pmannouncepg-inline-75 {
  font-size: 12px;
  color: #64748b;
  margin-bottom: 4px;
}

.pmannouncepg-inline-76 {
  font-size: 15px;
  font-weight: 600;
}

.pmannouncepg-inline-77 {
  font-size: 12px;
  color: #64748b;
  margin-bottom: 4px;
}

.pmannouncepg-inline-78 {
  font-size: 15px;
  font-weight: 600;
}

.pmannouncepg-inline-79 {
  margin-bottom: 28px;
}

.pmannouncepg-inline-80 {
  font-size: 16px;
  font-weight: 700;
  color: #0f172a;
  margin-bottom: 12px;
}

.pmannouncepg-inline-81 {
  background: #fff;
  border: 1px solid #e2e8f0;
  border-radius: 12px;
  padding: 24px;
  font-size: 15px;
  line-height: 1.8;
  color: #1e293b;
  white-space: pre-wrap;
  word-break: break-word;
}

.pmannouncepg-inline-82 {
  display: flex;
  gap: 12px;
  justify-content: flex-end;
  border-top: 1px solid #e2e8f0;
  padding-top: 24px;
}

.pmannouncepg-inline-83 {
  background: #3b82f6;
  border-color: #3b82f6;
}

.pmannouncepg-inline-84 {
  background: #ef4444;
  border-color: #ef4444;
}

.pmannouncepg-inline-85 {
  text-align: center;
}

.pmannouncepg-inline-86 {
  width: 64px;
  height: 64px;
  border-radius: 16px;
  background: #fee2e2;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #ef4444;
  margin: 0 auto 20px;
  font-size: 32px;
}

.pmannouncepg-inline-87 {
  font-size: 18px;
  font-weight: 700;
  color: #0f172a;
  margin-bottom: 8px;
}

.pmannouncepg-inline-88 {
  font-size: 14px;
  color: #64748b;
  margin-bottom: 16px;
}

.pmannouncepg-inline-89 {
  font-weight: 700;
  color: #0f172a;
}

.pmannouncepg-inline-90 {
  font-size: 13px;
  color: #b91c1c;
  background: #fef2f2;
  padding: 12px;
  border-radius: 8px;
  border: 1px solid #fecaca;
  margin-bottom: 24px;
}

.pmannouncepg-inline-91 {
  display: flex;
  gap: 12px;
  justify-content: center;
}

.pmannouncepg-inline-92 {
  background: #ef4444;
  border-color: #ef4444;
  padding: 10px 24px;
}

.pmannouncepg-dyn-6 {
  width: 40px;
  height: 40px;
  border-radius: 10px;
  background: var(--pmannouncepg-6-background);
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 20px;
}

.pmannouncepg-dyn-8 {
  width: 56px;
  height: 56px;
  border-radius: 16px;
  background: var(--pmannouncepg-8-background);
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 28px;
  color: #fff;
}

.pmannouncepg-dyn-9 {
  cursor: pointer;
  padding: 6px 16px;
  font-size: 12px;
}

.pmannouncepg-dyn-10 {
  cursor: pointer;
  padding: 6px 16px;
  font-size: 12px;
}

.pmannouncepg-dyn-11 {
  cursor: pointer;
  padding: 6px 16px;
  font-size: 12px;
}

.pmannouncepg-dyn-12 {
  cursor: pointer;
  padding: 6px 16px;
  font-size: 12px;
}

.pmannouncepg-dyn-13 {
  cursor: pointer;
  padding: 6px 16px;
  font-size: 12px;
}

.pmannouncepg-dyn-14 {
  font-size: 11px;
  padding: 4px 12px;
}

.pmannouncepg-dyn-15 {
  font-size: 12px;
  padding: 4px 16px;
}
`, "",{"version":3,"sources":["webpack://./src/assets/styles/PM/PMAnnouncePg.css"],"names":[],"mappings":"AAAA;EACE,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,mBAAmB;AACrB;;AAEA;EACE,iCAAiC;EACjC,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,SAAS;AACX;;AAEA;EACE,aAAa;EACb,SAAS;AACX;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,gBAAgB;EAChB,yBAAyB;EACzB,mBAAmB;EACnB,eAAe;EACf,YAAY;EACZ,YAAY;AACd;;AAEA;EACE,YAAY;EACZ,iBAAiB;EACjB,eAAe;EACf,WAAW;EACX,aAAa;EACb,uBAAuB;AACzB;;AAEA;EACE,YAAY;EACZ,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,qCAAqC;EACrC,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,8BAA8B;AAChC;;AAEA;EACE,eAAe;EACf,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,kBAAkB;EAClB,mBAAmB;EACnB,yBAAyB;AAC3B;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,QAAQ;AACV;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,iBAAiB;AACnB;;AAEA;EACE,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,YAAY;EACZ,iBAAiB;EACjB,eAAe;AACjB;;AAEA;EACE,mBAAmB;EACnB,mBAAmB;EACnB,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,gBAAgB;EAChB,0BAA0B;EAC1B,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,mBAAmB;EACnB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,UAAU;EACV,yBAAyB;EACzB,mBAAmB;EACnB,gBAAgB;EAChB,oBAAoB;EACpB,sCAAsC;AACxC;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;EACnB,gCAAgC;EAChC,aAAa;EACb,mBAAmB;EACnB,8BAA8B;AAChC;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,oBAAoB;EACpB,uBAAuB;EACvB,4BAA4B;EAC5B,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,6BAA6B;EAC7B,iBAAiB;EACjB,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,QAAQ;AACV;;AAEA;EACE,iBAAiB;EACjB,eAAe;AACjB;;AAEA;EACE,iBAAiB;EACjB,eAAe;AACjB;;AAEA;EACE,iBAAiB;EACjB,eAAe;EACf,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,yBAAyB;EACzB,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,yBAAyB;EACzB,gBAAgB;AAClB;;AAEA;EACE,6DAA6D;EAC7D,mBAAmB;EACnB,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,qCAAqC;EACrC,SAAS;EACT,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,yBAAyB;AAC3B;;AAEA;EACE,eAAe;EACf,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,yBAAyB;EACzB,mBAAmB;EACnB,aAAa;EACb,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,qBAAqB;EACrB,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,yBAAyB;EACzB,6BAA6B;EAC7B,iBAAiB;AACnB;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,cAAc;EACd,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,mBAAmB;EACnB,aAAa;EACb,kBAAkB;EAClB,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,uBAAuB;AACzB;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,4CAA4C;EAC5C,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,4CAA4C;EAC5C,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,WAAW;AACb;;AAEA;EACE,eAAe;EACf,iBAAiB;EACjB,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,iBAAiB;EACjB,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,iBAAiB;EACjB,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,iBAAiB;EACjB,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,iBAAiB;EACjB,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,eAAe;EACf,iBAAiB;AACnB","sourcesContent":[".pmannouncepg-inline-1 {\n  text-align: center;\n  padding: 60px 20px;\n}\n\n.pmannouncepg-inline-2 {\n  margin: 0 auto 20px;\n}\n\n.pmannouncepg-inline-3 {\n  font-size: 14px;\n  color: #64748b;\n}\n\n.pmannouncepg-inline-4 {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  margin-bottom: 20px;\n}\n\n.pmannouncepg-inline-5 {\n  font-family: 'Outfit', sans-serif;\n  font-size: 22px;\n  font-weight: 700;\n  color: #0f172a;\n  margin-bottom: 4px;\n}\n\n.pmannouncepg-inline-6 {\n  font-size: 13px;\n  color: #64748b;\n  margin: 0;\n}\n\n.pmannouncepg-inline-7 {\n  display: flex;\n  gap: 12px;\n}\n\n.pmannouncepg-inline-8 {\n  display: flex;\n  align-items: center;\n  background: #fff;\n  border: 1px solid #e2e8f0;\n  border-radius: 10px;\n  padding: 0 12px;\n  width: 260px;\n  height: 42px;\n}\n\n.pmannouncepg-inline-9 {\n  border: none;\n  padding: 10px 8px;\n  font-size: 13px;\n  width: 100%;\n  outline: none;\n  background: transparent;\n}\n\n.pmannouncepg-inline-10 {\n  height: 42px;\n  padding: 0 18px;\n}\n\n.pmannouncepg-inline-11 {\n  display: grid;\n  grid-template-columns: repeat(4, 1fr);\n  gap: 16px;\n  margin-bottom: 24px;\n}\n\n.pmannouncepg-inline-12 {\n  padding: 20px;\n  border-left: 4px solid #4338ca;\n}\n\n.pmannouncepg-inline-13 {\n  font-size: 13px;\n  color: #64748b;\n  margin-bottom: 8px;\n}\n\n.pmannouncepg-inline-14 {\n  font-size: 36px;\n  font-weight: 700;\n  color: #4338ca;\n  line-height: 1;\n}\n\n.pmannouncepg-inline-15 {\n  font-size: 12px;\n  color: #94a3b8;\n  margin-top: 8px;\n}\n\n.pmannouncepg-inline-16 {\n  padding: 20px;\n  border-left: 4px solid #2563eb;\n  background: #f8fafc;\n}\n\n.pmannouncepg-inline-17 {\n  font-size: 13px;\n  color: #64748b;\n  margin-bottom: 8px;\n}\n\n.pmannouncepg-inline-18 {\n  font-size: 36px;\n  font-weight: 700;\n  color: #2563eb;\n  line-height: 1;\n}\n\n.pmannouncepg-inline-19 {\n  font-size: 12px;\n  color: #94a3b8;\n  margin-top: 8px;\n}\n\n.pmannouncepg-inline-20 {\n  padding: 20px;\n  border-left: 4px solid #2563eb;\n  background: #f8fafc;\n}\n\n.pmannouncepg-inline-21 {\n  font-size: 13px;\n  color: #64748b;\n  margin-bottom: 8px;\n}\n\n.pmannouncepg-inline-22 {\n  font-size: 36px;\n  font-weight: 700;\n  color: #2563eb;\n  line-height: 1;\n}\n\n.pmannouncepg-inline-23 {\n  font-size: 12px;\n  color: #94a3b8;\n  margin-top: 8px;\n}\n\n.pmannouncepg-inline-24 {\n  padding: 20px;\n  border-left: 4px solid #d97706;\n  background: #f8fafc;\n}\n\n.pmannouncepg-inline-25 {\n  font-size: 13px;\n  color: #64748b;\n  margin-bottom: 8px;\n}\n\n.pmannouncepg-inline-26 {\n  font-size: 36px;\n  font-weight: 700;\n  color: #d97706;\n  line-height: 1;\n}\n\n.pmannouncepg-inline-27 {\n  font-size: 12px;\n  color: #94a3b8;\n  margin-top: 8px;\n}\n\n.pmannouncepg-inline-28 {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  margin-bottom: 24px;\n  flex-wrap: wrap;\n  background: #fff;\n  padding: 12px 16px;\n  border-radius: 12px;\n  border: 1px solid #e2e8f0;\n}\n\n.pmannouncepg-inline-29 {\n  font-size: 13px;\n  font-weight: 600;\n  color: #0f172a;\n}\n\n.pmannouncepg-inline-30 {\n  display: flex;\n  gap: 8px;\n}\n\n.pmannouncepg-inline-36 {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  margin-left: auto;\n}\n\n.pmannouncepg-inline-37 {\n  font-size: 13px;\n  color: #64748b;\n}\n\n.pmannouncepg-inline-38 {\n  width: 200px;\n  padding: 6px 12px;\n  font-size: 12px;\n}\n\n.pmannouncepg-inline-39 {\n  margin-bottom: 20px;\n  background: #eff6ff;\n  border-color: #86efac;\n  color: #166534;\n}\n\n.pmannouncepg-inline-40 {\n  text-align: center;\n  padding: 80px 20px;\n  background: #fff;\n  border: 2px dashed #e2e8f0;\n  border-radius: 16px;\n}\n\n.pmannouncepg-inline-41 {\n  font-size: 56px;\n  margin-bottom: 20px;\n}\n\n.pmannouncepg-inline-42 {\n  font-size: 20px;\n  font-weight: 700;\n  color: #0f172a;\n  margin-bottom: 12px;\n}\n\n.pmannouncepg-inline-43 {\n  font-size: 14px;\n  color: #64748b;\n  margin-bottom: 24px;\n  max-width: 500px;\n  margin: 0 auto 24px;\n}\n\n.pmannouncepg-inline-44 {\n  padding: 12px 24px;\n  font-size: 14px;\n}\n\n.pmannouncepg-inline-45 {\n  display: flex;\n  flex-direction: column;\n  gap: 16px;\n}\n\n.pmannouncepg-inline-46 {\n  padding: 0;\n  border: 1px solid #e2e8f0;\n  border-radius: 12px;\n  overflow: hidden;\n  transition: all 0.2s;\n  box-shadow: 0 1px 3px rgba(0,0,0,0.05);\n}\n\n.pmannouncepg-inline-47 {\n  padding: 16px 20px;\n  background: #f8fafc;\n  border-bottom: 1px solid #e2e8f0;\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n}\n\n.pmannouncepg-inline-48 {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n}\n\n.pmannouncepg-inline-49 {\n  font-size: 16px;\n  font-weight: 700;\n  color: #0f172a;\n  margin-bottom: 4px;\n}\n\n.pmannouncepg-inline-50 {\n  display: flex;\n  gap: 16px;\n  font-size: 12px;\n  color: #64748b;\n}\n\n.pmannouncepg-inline-52 {\n  padding: 16px 20px;\n}\n\n.pmannouncepg-inline-53 {\n  font-size: 13px;\n  line-height: 1.6;\n  color: #334155;\n  display: -webkit-box;\n  -webkit-line-clamp: 3px;\n  -webkit-box-orient: vertical;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  margin-bottom: 16px;\n}\n\n.pmannouncepg-inline-54 {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  border-top: 1px solid #f1f5f9;\n  padding-top: 16px;\n  margin-top: 8px;\n}\n\n.pmannouncepg-inline-55 {\n  font-size: 12px;\n  color: #64748b;\n}\n\n.pmannouncepg-inline-56 {\n  font-weight: 600;\n  color: #475569;\n}\n\n.pmannouncepg-inline-57 {\n  margin-left: 12px;\n}\n\n.pmannouncepg-inline-58 {\n  display: flex;\n  gap: 8px;\n}\n\n.pmannouncepg-inline-59 {\n  padding: 6px 14px;\n  font-size: 12px;\n}\n\n.pmannouncepg-inline-60 {\n  padding: 6px 14px;\n  font-size: 12px;\n}\n\n.pmannouncepg-inline-61 {\n  padding: 6px 14px;\n  font-size: 12px;\n  border-color: #fee2e2;\n  color: #ef4444;\n}\n\n.pmannouncepg-inline-62 {\n  resize: vertical;\n}\n\n.pmannouncepg-inline-63 {\n  display: flex;\n  gap: 12px;\n  justify-content: flex-end;\n  margin-top: 24px;\n}\n\n.pmannouncepg-inline-64 {\n  resize: vertical;\n}\n\n.pmannouncepg-inline-65 {\n  display: flex;\n  gap: 12px;\n  justify-content: flex-end;\n  margin-top: 24px;\n}\n\n.pmannouncepg-inline-66 {\n  background: linear-gradient(135deg, #f8fafc 0%, #f1f5f9 100%);\n  border-radius: 16px;\n  padding: 28px;\n  margin-bottom: 24px;\n}\n\n.pmannouncepg-inline-67 {\n  display: flex;\n  align-items: center;\n  gap: 16px;\n  margin-bottom: 20px;\n}\n\n.pmannouncepg-inline-68 {\n  font-size: 24px;\n  font-weight: 700;\n  color: #0f172a;\n  margin-bottom: 8px;\n}\n\n.pmannouncepg-inline-70 {\n  display: grid;\n  grid-template-columns: repeat(2, 1fr);\n  gap: 16px;\n  background: #fff;\n  padding: 20px;\n  border-radius: 12px;\n  border: 1px solid #e2e8f0;\n}\n\n.pmannouncepg-inline-71 {\n  font-size: 12px;\n  color: #64748b;\n  margin-bottom: 4px;\n}\n\n.pmannouncepg-inline-72 {\n  font-size: 15px;\n  font-weight: 600;\n}\n\n.pmannouncepg-inline-73 {\n  font-size: 12px;\n  color: #64748b;\n  margin-bottom: 4px;\n}\n\n.pmannouncepg-inline-74 {\n  font-size: 15px;\n  font-weight: 600;\n}\n\n.pmannouncepg-inline-75 {\n  font-size: 12px;\n  color: #64748b;\n  margin-bottom: 4px;\n}\n\n.pmannouncepg-inline-76 {\n  font-size: 15px;\n  font-weight: 600;\n}\n\n.pmannouncepg-inline-77 {\n  font-size: 12px;\n  color: #64748b;\n  margin-bottom: 4px;\n}\n\n.pmannouncepg-inline-78 {\n  font-size: 15px;\n  font-weight: 600;\n}\n\n.pmannouncepg-inline-79 {\n  margin-bottom: 28px;\n}\n\n.pmannouncepg-inline-80 {\n  font-size: 16px;\n  font-weight: 700;\n  color: #0f172a;\n  margin-bottom: 12px;\n}\n\n.pmannouncepg-inline-81 {\n  background: #fff;\n  border: 1px solid #e2e8f0;\n  border-radius: 12px;\n  padding: 24px;\n  font-size: 15px;\n  line-height: 1.8;\n  color: #1e293b;\n  white-space: pre-wrap;\n  word-break: break-word;\n}\n\n.pmannouncepg-inline-82 {\n  display: flex;\n  gap: 12px;\n  justify-content: flex-end;\n  border-top: 1px solid #e2e8f0;\n  padding-top: 24px;\n}\n\n.pmannouncepg-inline-83 {\n  background: #3b82f6;\n  border-color: #3b82f6;\n}\n\n.pmannouncepg-inline-84 {\n  background: #ef4444;\n  border-color: #ef4444;\n}\n\n.pmannouncepg-inline-85 {\n  text-align: center;\n}\n\n.pmannouncepg-inline-86 {\n  width: 64px;\n  height: 64px;\n  border-radius: 16px;\n  background: #fee2e2;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  color: #ef4444;\n  margin: 0 auto 20px;\n  font-size: 32px;\n}\n\n.pmannouncepg-inline-87 {\n  font-size: 18px;\n  font-weight: 700;\n  color: #0f172a;\n  margin-bottom: 8px;\n}\n\n.pmannouncepg-inline-88 {\n  font-size: 14px;\n  color: #64748b;\n  margin-bottom: 16px;\n}\n\n.pmannouncepg-inline-89 {\n  font-weight: 700;\n  color: #0f172a;\n}\n\n.pmannouncepg-inline-90 {\n  font-size: 13px;\n  color: #b91c1c;\n  background: #fef2f2;\n  padding: 12px;\n  border-radius: 8px;\n  border: 1px solid #fecaca;\n  margin-bottom: 24px;\n}\n\n.pmannouncepg-inline-91 {\n  display: flex;\n  gap: 12px;\n  justify-content: center;\n}\n\n.pmannouncepg-inline-92 {\n  background: #ef4444;\n  border-color: #ef4444;\n  padding: 10px 24px;\n}\n\n.pmannouncepg-dyn-6 {\n  width: 40px;\n  height: 40px;\n  border-radius: 10px;\n  background: var(--pmannouncepg-6-background);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  font-size: 20px;\n}\n\n.pmannouncepg-dyn-8 {\n  width: 56px;\n  height: 56px;\n  border-radius: 16px;\n  background: var(--pmannouncepg-8-background);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  font-size: 28px;\n  color: #fff;\n}\n\n.pmannouncepg-dyn-9 {\n  cursor: pointer;\n  padding: 6px 16px;\n  font-size: 12px;\n}\n\n.pmannouncepg-dyn-10 {\n  cursor: pointer;\n  padding: 6px 16px;\n  font-size: 12px;\n}\n\n.pmannouncepg-dyn-11 {\n  cursor: pointer;\n  padding: 6px 16px;\n  font-size: 12px;\n}\n\n.pmannouncepg-dyn-12 {\n  cursor: pointer;\n  padding: 6px 16px;\n  font-size: 12px;\n}\n\n.pmannouncepg-dyn-13 {\n  cursor: pointer;\n  padding: 6px 16px;\n  font-size: 12px;\n}\n\n.pmannouncepg-dyn-14 {\n  font-size: 11px;\n  padding: 4px 12px;\n}\n\n.pmannouncepg-dyn-15 {\n  font-size: 12px;\n  padding: 4px 16px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
